$bog_music_log_view $mol_list
	rows <= log_rows /
	Head $mol_view
		sub /
			<= Count $mol_view
				sub / <= count_label \
			<= Version $mol_view
				sub / <= version \
			<= Tools $mol_view
				sub /
					<= Sync $mol_check_box
						title \Логи синка
						checked? <=> sync_logging? false
					<= Copy $mol_button_minor
						title \Скопировать
						click? <=> copy? null
					<= Clear $mol_button_minor
						title \Очистить
						click? <=> clear? null
	Filter $mol_string
		value? <=> filter? \
		hint \Фильтр: ленд, действие или текст ошибки
	Row* $mol_view
		attr *
			mol_theme <= row_theme* \
			bog_music_log_kind <= kind_id* \
		sub /
			<= Meta* $mol_view
				sub /
					<= Time* $mol_view
						sub / <= time* \
					<= Kind* $mol_view
						sub / <= kind* \
					<= Land* $mol_view
						sub / <= land* \
			<= Text* $mol_view
				sub / <= text* \
	Empty $mol_view
		sub / <= empty_label \
